









import { defineComponent, getCurrentInstance, computed, ref, watch } from '@vue/composition-api';

import AgreementCheckbox, { AgreementComponent } from '@/renderer/components/Base/Agreement/AgreementCheckbox.vue';

import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import dispatchWebview from '@/renderer/scripts/utils/tools/dispatchWebview';
import smh from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { IS_BROWSER } from '@/common/constant/platform';
import { encodeText } from '@/renderer/scripts/utils/tools';
import user from '@/renderer/scripts/utils/user';
import { i18n_t } from '@/locales/i18n';

export default defineComponent({
  components: {
    AgreementCheckbox,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const store = vm.$store;
    // 交大只有一个企业 企业id默认取企业列表第一条就行
    const corpId = computed(() => {
      const list = store.getters.corpList;
      return list.length > 0 ? list[0].corpId : '';
    });
    const agreementRef = ref<AgreementComponent | null>(null);

    const methods = {
      async loginWithJAccount() {
        // jaccount登录逻辑
        // if (!agreementRef.value?.validate()) {
        //   return;
        // }
        if (!corpId.value) {
          tips.error(i18n_t('请联系运维管理员处理'));
          return;
        }
        try {
          // 记录当前路由，便于web端跳转
          let path = IS_BROWSER ? `${window.location.pathname}${window.location.search}` : '';
          if (path) {
            path = encodeURIComponent(encodeURIComponent(encodeText(path)));
          }
          const { data } = await smh.api.getSSOurl({
            orgDomain: encodeURIComponent(corpId.value),
            from: IS_BROWSER ? 'web' : 'pc',
            custom_state: path,
          });
          if (data.url) {
            // 记录是web还是pc打开 pc端打开sso url登录后需要唤起桌面应用
            user.setSSOFrom(IS_BROWSER ? 'web' : 'pc');
            // 记录企业id
            user.setCorpid(corpId.value);
            // web本页面跳转
            if (IS_BROWSER) {
              dispatchRouter(data.url, '_self');
            } else {
              dispatchWebview({ url: data.url, className: 'sjtu' });
            }
          }
        } catch (error) {
          tips.error(error as MsgError);
        }
      },
      validate() {
        return agreementRef.value?.validate();
      },
    };
    return {
      agreementRef,
      ...methods,
    };
  },
});
